export const DESIGNATION_LIST = "DESIGNATION_LIST";
export const USER_LIST = "USER_LIST";
export const ADD_FAMILYDETAILS = "ADD_FAMILYDETAILS";
export const ADD_EDUCATIONDETAILS = "ADD_EDUCATIONDETAILS";
export const ADD_EXPERIENCEDETAILS = "ADD_EXPERINCEDETAILS";
export const ADD_PERSONALDETAILS = "ADD_PERSONALDETAILS";
export const PERSONAL_DETAILS = "PERSONAL_DETAILS";
export const FAMILY_DETAILS = "FAMILY_DETAILS";
export const EDUCATION_DETAILS = "EDUCATION_DETAILS";
export const EXPERIENCE_DETAILS = "EXPERINCE_DETAILS";
export const VALIDATE_USER = "VALIDATE_USER";
export const CREATE_USER = "CREATE_USER";
export const DOCUMENT_LIST = "DOCUMENT_LIST";
export const ADD_DOCUMENT_DETAILS = "ADD_DOCUMENT_DETAILS";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const USER_DOCUMENT_LIST = "USER_DOCUMENT_LIST";
export const INITIATE_NEWHIRE = "INITIATE_NEWHIRE";
export const OFFER_GENERATE = "OFFER_GENERATE";
export const UPDATE_ONBOARDING = "UPDATE_ONBOARDING";
export const USER_DETAILS = "USER_DETAILS";
export const NEWHIRE_USER_DETAILS = "NEWHIRE_USER_DETAILS";
export const EMP_USER_DETAILS = "EMP_USER_DETAILS";
export const ONBOARD_USER_DETAILS = "ONBOARD_USER_DETAILS";
export const ROLE_LIST = "ROLE_LIST";
export const OFFER_DETAILS = "OFFER_DETAILS";
export const ACCEPT_OFFER = "ACCEPT_OFFER";
export const APPROVE_NEWHIRE = "APPROVE_NEWHIRE";
export const EMPLOYEE_LIST = "EMPLOYEE_LIST";
export const EMPLOYEE_DATA_EXCEL = "EMPLOYEE_DATA_EXCEL";
export const SUPPORT_DATA_EXCEL = "SUPPORT_DATA_EXCEL";
export const CONTRACT_DATA_EXCEL = "CONTRACT_DATA_EXCEL";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const EXIT_EMPLOYEE = "EXIT_EMPLOYEE";
export const NEW_HIRE_TRANSACTION = "NEW_HIRE_TRANSACTION";
export const OFFER_ACCEPTED = "OFFER_ACCEPTED";
export const CONTRACT_EMPLOYEE_LIST = "CONTRACT_EMPLOYEE_LIST";
export const SUPPORT_EMPLOYEE_LIST = "SUPPORT_EMPLOYEE_LIST";
export const ALL_EMPLOYEE_LIST = "ALL_EMPLOYEE_LIST";
export const EMPLOYEE_DATA = "EMPLOYEE_DATA";
export const INSTANT_ONBOARD = "INSTANT_ONBOARD";
